module.exports = __webpack_public_path__ + "static/media/header-banner-loans.47f41ad5.svg";